import React from 'react'
import '../Concierge/concierge.css'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import '../Concierge/concierge-responsive.css'

/**
 * KashtaAddOns - Dedicated AddOns component for Kashta/Event booking flow
 * Uses event-specific APIs for catering functionality
 */
class KashtaAddOns extends React.Component {
    state = {
        activeTab: this.props.data.tab[0].id,
        activeAddOnTab: {},
        activeAddOnSubTab: 0,
        isLoading: false,
        initialLoading: false,
        tabList: this.props.data.tab,
        bookingId: this.props.data.id,
        title: this.props.data?.event_data?.event_name || '',
        circleTab: [],
        foodOrStoreSelectOnceData: {},
        cartList: [],
        cartItemList: {},
        showCart: false,
        descriptionExpand: 1,
        totalAmt: 0,
        bookingData: {},
        showCheckout: false,
        storeMinAmtOrder: {},
        detailsOfitem: null,
        enable_b2b_prices: this.props.data.enable_b2b_prices,
        event_id: this.props.data.event_id || '',
        slot_id: this.props.data.slot_id || '',
        bookingPayload: this.props.data.bookingPayload || {},
        // Catering specific state
        showItemDetail: false,
        selectedItem: null,
        personCount: 0,
        selectedCateringOptions: {}, // { categoryId: { itemId: qty } }
        specialRequest: '',
        // Individual loading states
        isLoadingStores: false,
        isLoadingItems: false,
        isProcessingCheckout: false,
        isProcessingPayment: false,
    }

    componentDidMount() {
        this.imageManger = this.imageManger.bind(this)
        this.storeMinOrderAmtAlert = this.storeMinOrderAmtAlert.bind(this)
        this.tabHandler()
    }

    // Inline loader component
    renderInlineLoader = (height = 100) => {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: height,
                    width: '100%',
                }}
            >
                <div
                    style={{
                        width: 30,
                        height: 30,
                        border: '3px solid #f3f3f3',
                        borderTop: '3px solid #00547e',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                    }}
                />
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        )
    }

    setActiveTab = (tabDetail) => {
        this.setState({ activeTab: tabDetail, activeAddOnSubTab: 0 }, () => {
            this.tabHandler()
        })
    }

    setActiveAddOnTab = (subTabName) => {
        this.setState({ activeAddOnTab: subTabName, activeAddOnSubTab: 0 }, () => {
            this.getEventStoreItems()
        })
    }

    setActiveAddOnSubTab = (subChildTabName) => {
        this.setState({ activeAddOnSubTab: subChildTabName })
    }

    tabHandler = () => {
        this.getEventStoreList()
    }

    // Event-specific API to get store list
    getEventStoreList = () => {
        this.setState({
            isLoadingStores: true,
        })

        const apiUrl = Constant.getAPI() + `/event/get-event-store-list?type=${this.state.activeTab}&event_id=${this.state.event_id}&slot_id=${this.state.slot_id}`

        axios
            .get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState(
                        {
                            circleTab: res.data.data,
                        },
                        () => {
                            if (res.data.data && res.data.data.length > 0) {
                                this.setActiveAddOnTab(res.data.data[0])
                            }
                        }
                    )
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
            .finally(() => {
                this.setState({
                    isLoadingStores: false,
                })
            })
    }

    // Event-specific API to get store items
    getEventStoreItems = () => {
        if (!this.state.activeAddOnTab?.id) return

        this.setState({
            isLoadingItems: true,
        })

        const apiUrl = Constant.getAPI() + `/event/get-store-items-list/${this.state.activeAddOnTab.id}?event_id=${this.state.event_id}`

        axios
            .get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        foodOrStoreSelectOnceData: res.data.data,
                    })
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
            .finally(() => {
                this.setState({
                    isLoadingItems: false,
                })
            })
    }

    imageManger = (value) => {
        let imgUrl = Constant.getImage()
        if (value) {
            imgUrl = imgUrl + value
        } else {
            imgUrl = './assets/images/waves-logo.svg'
        }

        return (
            <img
                alt=""
                src={imgUrl}
                onError={({ currentTarget }) => {
                    currentTarget.src = './assets/images/waves-logo.svg'
                }}
            />
        )
    }

    addOrRemoveFromCart = async (data, value) => {
        let obj = { ...data }
        let total = 0
        let StoreObj = { ...this.state.storeMinAmtOrder }
        if (this.state.itemaddingRemove) {
            return
        }
        let id = obj.id
        let price = obj.price
        let list = this.state.cartItemList

        if (!value) {
            if (!(list['id' + id] && list['id' + id].id)) {
                return
            } else {
                list['id' + id].qty = list['id' + id].qty - 1
                if (list['id' + id].qty == 0) {
                    delete list['id' + id]
                }
                if (obj.storeId) {
                    let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
                    StoreObj['pId' + obj.storeId] = {
                        amt: totalAmtOfStireItem - price,
                        orderAmt: data.orderAmt,
                        name: data.storeName,
                    }
                }
                total = this.state.totalAmt - price
            }
        } else {
            let qtyIs = list['id' + id] ? list['id' + id].qty : 0
            if (obj.stock_limit && obj.stock_limit <= qtyIs) {
                Swal.fire('Item out of Stock', '', 'warning')
                return
            }
            if (!(list['id' + id] && list['id' + id].id)) {
                list['id' + id] = {
                    ...obj,
                    qty: 1,
                    id: obj.id,
                    img: obj.img,
                    title: obj.title,
                    price: obj.price,
                    notes: obj.notes,
                    store_item_option_id: obj.store_item_option_id,
                }
            } else {
                if (list['id' + id].qty > 0) {
                    list['id' + id].qty = list['id' + id].qty + 1
                }
            }
            if (obj.storeId) {
                let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
                StoreObj['pId' + obj.storeId] = {
                    amt: totalAmtOfStireItem + price,
                    orderAmt: data.orderAmt,
                    name: data.storeName,
                }
            }
            total = this.state.totalAmt + price
        }
        this.setState({
            cartItemList: { ...list },
            totalAmt: total,
            storeMinAmtOrder: { ...StoreObj },
        })
    }

    Checkout = () => {
        let arr = Object.values(this.state.cartItemList)
        let additional_items_list = []
        let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt != 0)
        if (a) {
            Swal.fire(
                `${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} mininum`,
                '',
                'warning'
            )
            return
        }
        for (let item of arr) {
            let totalItemQty = item.qty || 1

            // If it's a catering item, build catering_items array and calculate total qty
            if (item.isCateringItem && item.cateringCategories && item.selectedCateringOptions) {
                const cateringItems = []
                let totalCateringQty = 0

                item.cateringCategories.forEach((category) => {
                    const categoryOptions = item.selectedCateringOptions[category.id] || {}
                    category.items.forEach((catItem) => {
                        const qty = categoryOptions[catItem.id] || 0
                        if (qty > 0) {
                            totalCateringQty += qty
                            cateringItems.push({
                                amount: catItem.price || 0,
                                category_id: category.id,
                                is_addon: category.is_addon || false,
                                item_id: catItem.id,
                                item_qty: qty,
                            })
                        }
                    })
                })

                // Use total catering qty or personCount as item_qty
                totalItemQty = item.personCount || totalCateringQty || 1

                const itemData = {
                    add_item_id: item.id,
                    amount: String(item.price),
                    store_id: item.storeId || item.store_id,
                    item_qty: String(totalItemQty),
                    notes: item?.notes || '',
                    store_item_option_id: item?.store_item_option_id || '',
                    chalet_id: '',
                    catering_items: cateringItems,
                }
                additional_items_list.push(itemData)
            } else {
                // Regular item
                const itemData = {
                    add_item_id: item.id,
                    amount: String(item.price),
                    store_id: item.storeId || item.store_id,
                    item_qty: String(totalItemQty),
                    notes: item?.notes || '',
                    store_item_option_id: item?.store_item_option_id || '',
                    chalet_id: '',
                }
                additional_items_list.push(itemData)
            }
        }
        const data = {
            // diwaniya_items_list: [],
            additional_items_list: additional_items_list,
            booking_id: this.state.bookingId,
            is_b2b: this.state.enable_b2b_prices,
        }
        this.onCheckout(data)
    }

    productCard = (img, title, price, data, checkQty = 0) => {
        let obj = data
        obj['qty'] = this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].qty || 0 : 0
        obj['store_item_option_id'] = this.state.cartItemList['id' + data.id]
            ? this.state.cartItemList['id' + data.id].store_item_option_id || ''
            : ''
        obj['notes'] = this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].notes || '' : ''
        obj['img'] = img
        obj['title'] = title
        obj['price'] = price

        if (checkQty && !obj.qty) {
            return
        }
        return (
            <div className="add-box-data">
                <div onClick={() => this.setState({ detailsOfitem: data })}>{this.imageManger(img)}</div>
                <div className="box-under-data">
                    <p>{title}</p>
                    <div className="under-data-price">
                        <p>
                            {this.state.cartItemList['id' + data.id] ? this.state.cartItemList['id' + data.id].price : price}{' '}
                            {getCurrency(localStorage.getItem('countryShortName'))}
                        </p>
                        {data.store_item_options && data.store_item_options.length ? (
                            <div
                                className="showwAll"
                                onClick={() => this.setState({ detailsOfitem: obj })}
                            >
                                Show All
                            </div>
                        ) : (
                            <div className="count-data">
                                <span
                                    className="box"
                                    onClick={() => this.addOrRemoveFromCart(data, 0)}
                                >
                                    -
                                </span>
                                <div>{obj.qty}</div>
                                <span
                                    className="box"
                                    onClick={() => this.addOrRemoveFromCart(data, 1)}
                                >
                                    +
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    handleCart = () => {
        this.setState({ showCart: this.state.showCheckout ? 1 : 0, showCheckout: 0 })
    }

    // Event-specific checkout API using admin-event-book
    onCheckout = async (data) => {
        this.setState({ isData: true, isProcessingCheckout: true, bookingData: {} })

        // Build the payload similar to ConciergeKashtaAdd.js
        const { bookingPayload, event_id, slot_id } = this.state
        const payload = {
            phone: bookingPayload.phone,
            email: bookingPayload.email,
            country_code: bookingPayload.country_code,
            event_id: event_id,
            slot_id: slot_id,
            ticket_count: bookingPayload.ticket_count,
            child_ticket_count: bookingPayload.child_ticket_count,
            coupon_id: bookingPayload.coupon_id || '',
            cost_of_service: bookingPayload.cost_of_service,
            isB2B: bookingPayload.isB2B,
            additional_items_list: data.additional_items_list,
        }

        await axios
            .post(Constant.getAPI() + '/booking/admin-event-book', payload, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        bookingData: res.data.data,
                        showCheckout: true,
                    })
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
            .finally(() => {
                this.setState({
                    isData: false,
                    isProcessingCheckout: false,
                })
            })
    }

    // Build additional_items_list from cart
    buildAdditionalItemsList = () => {
        const arr = Object.values(this.state.cartItemList)
        const additional_items_list = []

        for (const item of arr) {
            let totalItemQty = item.qty || 1

            if (item.isCateringItem && item.cateringCategories && item.selectedCateringOptions) {
                const cateringItems = []
                let totalCateringQty = 0

                item.cateringCategories.forEach((category) => {
                    const categoryOptions = item.selectedCateringOptions[category.id] || {}
                    category.items.forEach((catItem) => {
                        const qty = categoryOptions[catItem.id] || 0
                        if (qty > 0) {
                            totalCateringQty += qty
                            cateringItems.push({
                                amount: catItem.price || 0,
                                category_id: category.id,
                                is_addon: category.is_addon || false,
                                item_id: catItem.id,
                                item_qty: qty,
                            })
                        }
                    })
                })

                totalItemQty = item.personCount || totalCateringQty || 1

                additional_items_list.push({
                    add_item_id: item.id,
                    item_qty: totalItemQty,
                    store_item_option_id: item?.store_item_option_id || '',
                    notes: item?.notes || '',
                    catering_items: cateringItems,
                })
            } else {
                additional_items_list.push({
                    add_item_id: item.id,
                    item_qty: totalItemQty,
                    store_item_option_id: item?.store_item_option_id || '',
                    notes: item?.notes || '',
                })
            }
        }

        return additional_items_list
    }

    // Event-specific payment API
    processPayment = async () => {
        this.setState({ isProcessingPayment: true })

        const { bookingPayload, event_id, slot_id, bookingData } = this.state
        const additional_items_list = this.buildAdditionalItemsList()

        const body = {
            user_id: bookingData?.user_id || '',
            event_id: event_id,
            slot_id: slot_id,
            DisplayCurrencyIso: getCurrency(localStorage.getItem('countryShortName')),
            ticket_count: bookingPayload?.ticket_count || 0,
            child_ticket_count: bookingPayload?.child_ticket_count || 0,
            coupon_id: bookingPayload?.coupon_id || '',
            cost_of_service: bookingPayload?.cost_of_service || 0,
            isB2B: this.state.enable_b2b_prices,
            additional_items_list: additional_items_list,
        }

        await axios
            .post(Constant.getAPI() + '/booking/process-event-payment', body, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                if (res?.data?.success) {
                    Swal.fire({
                        title: 'Payment Success',
                        icon: 'success',
                        text: '',
                        type: 'success',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Booking Details',
                    }).then(() => {
                        window.location.href = `#/new-evt/${res?.data?.data?.booking_id}`
                    })
                    this.props.clearData()
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
            .finally(() => {
                this.setState({
                    isProcessingPayment: false,
                })
            })
    }

    bottmBtn = () => {
        if (this.state.showCart) {
            this.Checkout()
        } else {
            let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt != 0)
            if (a) {
                Swal.fire(
                    `${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} mininum`,
                    '',
                    'warning'
                )
                return
            }
            let tabList = [...this.state.tabList]
            let indexOfCurrentTab =
                this.state.tabList.findIndex((ele) => {
                    return ele.id == this.state.activeTab
                }) + 1
            if (indexOfCurrentTab == tabList.length) {
                this.setState({
                    showCart: 1,
                })
            } else {
                this.setActiveTab(tabList[indexOfCurrentTab].id)
            }
        }
    }

    storeMinOrderAmtAlert = () => {
        let store = this.state.storeMinAmtOrder['pId' + this.state.foodOrStoreSelectOnceData.id]
        if (store && store.amt < store.orderAmt && store.amt != 0 && !this.state.showCart && !this.state.showCheckout) {
            return (
                <div
                    style={{
                        background: 'aqua',
                        fontSize: '13px',
                        textAlign: 'center',
                    }}
                >
                    Minimum Order limit of {store.name} is {store.orderAmt}{' '}
                    {getCurrency(localStorage.getItem('countryShortName'))}
                </div>
            )
        } else {
            return ''
        }
    }

    changeItemDetail = (type, value, other) => {
        let obj = { ...this.state.detailsOfitem }
        if (type == 'QTY') {
            obj.qty = (obj.qty || 0) + (value ? 1 : -1)
            if (other < obj.qty) {
                Swal.fire('Item out of Stock', '', 'warning')
                return
            }

            if (obj.qty < 0) {
                return
            }

            if (obj.qty == 0) {
                obj['notes'] = ''
                obj['store_item_option_id'] = ''
            }
        }

        if (type == 'NOT') {
            obj['notes'] = value
        }

        if (type == 'OPT') {
            obj['store_item_option_id'] = value

            let store_item_option = other.find((e) => {
                return e.id == value
            })
            obj['price'] = store_item_option.price
        }
        this.setState({ detailsOfitem: obj })
    }

    setDetailsOfitem = () => {
        let data = this.state.detailsOfitem
        return (
            <div>
                <div className="App">
                    <div
                        className="popup-backdrop"
                        onClick={() => this.setState({ detailsOfitem: '' })}
                    >
                        <div
                            className="popup-content height-width-fix"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="popup-close"
                                onClick={() => this.setState({ detailsOfitem: '' })}
                            >
                                <img
                                    src="./assets/icon/concierge/close-black.svg"
                                    alt=""
                                />
                            </button>
                            <div className="popupScroll">
                                <div className="popup-data">
                                    <div className="w-50">
                                        <div>
                                            <div className="slider-container img-250">{this.imageManger(data.img)}</div>
                                        </div>
                                    </div>
                                    <div className="w-50">
                                        <div>
                                            <h3 className="m-0">{data.title}</h3>
                                            <div
                                                className="review-location"
                                                style={{ height: '100px', alignItems: 'flex-start', lineHeight: '14px', fontSize: '10px' }}
                                            >
                                                {data.description}
                                            </div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-8">
                                                        {data.store_item_options && data.store_item_options.length ? (
                                                            <div className="item-dropdown">
                                                                <div
                                                                    className="w-100"
                                                                    style={{ lineHeight: '32px' }}
                                                                >
                                                                    Chose Your size
                                                                </div>
                                                                <div className="w-100">
                                                                    <select
                                                                        style={{ width: '100%', padding: '0', textAlign: 'center' }}
                                                                        name="country_code"
                                                                        className="form-control border-none"
                                                                        value={data.store_item_option_id}
                                                                        onChange={(event) => {
                                                                            this.changeItemDetail('OPT', event.target.value, data.store_item_options)
                                                                        }}
                                                                    >
                                                                        {data.store_item_options.map((ele) => {
                                                                            return <option value={ele.id}>{ele.name}</option>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                    <div className="detail-price2 col-4">
                                                        {data.price} {getCurrency(localStorage.getItem('countryShortName'))}
                                                    </div>
                                                    <textarea
                                                        type="text"
                                                        disabled={(data.qty || 0) == 0}
                                                        className="form-control cruise_search col-12 my-2"
                                                        style={{ height: '46px' }}
                                                        name="cruise_search"
                                                        id="cruise_search"
                                                        placeholder={`Any Special request`}
                                                        onChange={(event) => {
                                                            this.changeItemDetail('NOT', event.target.value, '')
                                                        }}
                                                        value={data.notes}
                                                    />
                                                    <div className="count-data col-6">
                                                        <span
                                                            className="box"
                                                            onClick={() => this.changeItemDetail('QTY', 0, data.stock_limit)}
                                                        >
                                                            -
                                                        </span>
                                                        <div>{data.qty || 0}</div>
                                                        <span
                                                            className="box"
                                                            onClick={() => this.changeItemDetail('QTY', 1, data.stock_limit)}
                                                        >
                                                            +
                                                        </span>
                                                    </div>
                                                    <div className="col-6">
                                                        <button
                                                            className="btn book-btn "
                                                            disabled={(data.qty || 0) == 0}
                                                            type="button"
                                                            onClick={() => this.addBulkQty()}
                                                        >
                                                            Add To Cart {data.price * data.qty || 0}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    addBulkQty = () => {
        let list = this.state.cartItemList
        let StoreObj = { ...this.state.storeMinAmtOrder }
        let prevPrice = 0
        let prevQty = 0
        let obj = this.state.detailsOfitem
        let id = this.state.detailsOfitem.id
        if (list['id' + id]) {
            prevPrice = list['id' + id].price
            prevQty = list['id' + id].qty
        }
        list['id' + id] = {
            ...obj,
        }
        let min = -(prevPrice * prevQty)
        if (obj.storeId) {
            let totalAmtOfStireItem = StoreObj['pId' + obj.storeId] ? StoreObj['pId' + obj.storeId]?.amt : 0
            StoreObj['pId' + obj.storeId] = {
                amt: totalAmtOfStireItem + min + obj.price * obj.qty,
                orderAmt: obj.orderAmt,
                name: obj.storeName,
            }
        }

        this.setState({
            totalAmt: this.state.totalAmt + min + obj.price * obj.qty,
            cartItemList: { ...list },
            storeMinAmtOrder: { ...StoreObj },
            detailsOfitem: {},
        })
    }

    // ==================== CATERING SPECIFIC METHODS ====================

    // Open catering item detail view
    openCateringItemDetail = (item) => {
        this.setState({
            showItemDetail: true,
            selectedItem: item,
            personCount: item.min_persons || 1,
            selectedCateringOptions: {},
            specialRequest: '',
        })
    }

    // Close catering item detail view
    closeCateringItemDetail = () => {
        this.setState({
            showItemDetail: false,
            selectedItem: null,
            personCount: 0,
            selectedCateringOptions: {},
            specialRequest: '',
        })
    }

    // Handle person count change
    // min_persons: minimum allowed persons
    // max_persons: maximum allowed persons
    // person_price: price per extra person (above min_persons)
    handlePersonCount = (increment) => {
        const { selectedItem, personCount } = this.state
        const minPersons = selectedItem?.min_persons || 1
        const maxPersons = selectedItem?.max_persons || 100

        if (increment) {
            if (personCount < maxPersons) {
                this.setState({ personCount: personCount + 1 })
            } else {
                Swal.fire(`Maximum ${maxPersons} persons allowed`, '', 'warning')
            }
        } else {
            if (personCount > minPersons) {
                this.setState({ personCount: personCount - 1 })
            } else {
                Swal.fire(`Minimum ${minPersons} persons required`, '', 'warning')
            }
        }
    }

    // Handle catering option selection
    // selection: 'single' means only 1 qty allowed per item, 'multiple' means multiple qty allowed
    handleCateringOptionChange = (categoryId, itemId, increment, maxItems, selectionType = 'multiple') => {
        const { selectedCateringOptions } = this.state
        const categoryOptions = selectedCateringOptions[categoryId] || {}
        const currentQty = categoryOptions[itemId] || 0

        // Calculate total selected in this category
        const totalInCategory = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)

        if (increment) {
            // Check if we can add more based on max_items
            if (totalInCategory < maxItems) {
                // For 'single' selection type, max qty per item is 1
                if (selectionType === 'single' && currentQty >= 1) {
                    Swal.fire('Only 1 quantity allowed for this item', '', 'warning')
                    return
                }
                this.setState({
                    selectedCateringOptions: {
                        ...selectedCateringOptions,
                        [categoryId]: {
                            ...categoryOptions,
                            [itemId]: currentQty + 1,
                        },
                    },
                })
            } else {
                Swal.fire(`Maximum ${maxItems} items allowed in this category`, '', 'warning')
            }
        } else {
            if (currentQty > 0) {
                const newQty = currentQty - 1
                const newCategoryOptions = { ...categoryOptions }
                if (newQty === 0) {
                    delete newCategoryOptions[itemId]
                } else {
                    newCategoryOptions[itemId] = newQty
                }
                this.setState({
                    selectedCateringOptions: {
                        ...selectedCateringOptions,
                        [categoryId]: newCategoryOptions,
                    },
                })
            }
        }
    }

    // Get remaining items to choose for a category
    getRemainingItems = (categoryId, maxItems) => {
        const { selectedCateringOptions } = this.state
        const categoryOptions = selectedCateringOptions[categoryId] || {}
        const totalSelected = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)
        return maxItems - totalSelected
    }

    // Calculate total price for catering item
    calculateCateringTotal = () => {
        const { selectedItem, selectedCateringOptions, personCount } = this.state
        if (!selectedItem) return 0

        // Base price
        let total = selectedItem.item_amount || 0

        // Calculate extra person price if personCount exceeds min_persons
        const minPersons = selectedItem.min_persons || 0
        const personPrice = selectedItem.person_price || 0
        if (personCount > minPersons && personPrice > 0) {
            const extraPersons = personCount - minPersons
            total += extraPersons * personPrice
        }

        // Add addon prices (only for is_addon: true categories)
        if (selectedItem.catering_categories) {
            selectedItem.catering_categories.forEach((category) => {
                if (category.is_addon) {
                    const categoryOptions = selectedCateringOptions[category.id] || {}
                    category.items.forEach((item) => {
                        const qty = categoryOptions[item.id] || 0
                        total += item.price * qty
                    })
                }
            })
        }

        return total
    }

    // Validate required categories have all items selected
    validateRequiredCategories = () => {
        const { selectedItem, selectedCateringOptions } = this.state
        if (!selectedItem || !selectedItem.catering_categories) return { valid: true }

        for (const category of selectedItem.catering_categories) {
            // Skip addon categories - they are optional
            if (category.is_addon) continue

            const maxItems = category.max_items || 0
            if (maxItems > 0) {
                const categoryOptions = selectedCateringOptions[category.id] || {}
                const totalSelected = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)
                if (totalSelected < maxItems) {
                    return {
                        valid: false,
                        categoryName: category.name,
                        remaining: maxItems - totalSelected,
                    }
                }
            }
        }
        return { valid: true }
    }

    // Add catering item to cart
    addCateringItemToCart = () => {
        const { selectedItem, personCount, selectedCateringOptions, specialRequest, cartItemList, totalAmt, storeMinAmtOrder } = this.state

        if (!selectedItem) return

        // Validate required categories
        const validation = this.validateRequiredCategories()
        if (!validation.valid) {
            Swal.fire({
                title: `Please select ${validation.remaining} more item(s) in "${validation.categoryName}"`,
                icon: 'warning',
                confirmButtonColor: '#00547e',
                confirmButtonText: 'Ok',
            })
            return
        }

        const itemTotal = this.calculateCateringTotal()
        const itemId = selectedItem.id

        const cartItem = {
            id: itemId,
            store_id: selectedItem.store_id,
            title: selectedItem.name,
            img: selectedItem.image,
            price: itemTotal,
            qty: 1,
            personCount: personCount,
            selectedCateringOptions: { ...selectedCateringOptions },
            cateringCategories: selectedItem.catering_categories || [], // Store categories for cart display
            notes: specialRequest,
            isCateringItem: true,
            storeId: this.state.foodOrStoreSelectOnceData?.id,
            orderAmt: this.state.foodOrStoreSelectOnceData?.minimumOrderAmount || 0,
            storeName: this.state.foodOrStoreSelectOnceData?.name,
        }

        const newCartList = { ...cartItemList }
        newCartList['id' + itemId] = cartItem

        // Update store min order tracking
        const StoreObj = { ...storeMinAmtOrder }
        const storeId = this.state.foodOrStoreSelectOnceData?.id
        if (storeId) {
            const prevAmt = StoreObj['pId' + storeId]?.amt || 0
            StoreObj['pId' + storeId] = {
                amt: prevAmt + itemTotal,
                orderAmt: this.state.foodOrStoreSelectOnceData?.minimumOrderAmount || 0,
                name: this.state.foodOrStoreSelectOnceData?.name,
            }
        }

        this.setState({
            cartItemList: newCartList,
            totalAmt: totalAmt + itemTotal,
            storeMinAmtOrder: StoreObj,
        })

        this.closeCateringItemDetail()
        Swal.fire('Added to cart!', '', 'success')
    }

    // Render catering item detail view - shows inline in the same popup
    renderCateringItemDetail = () => {
        const { selectedItem, personCount, selectedCateringOptions, specialRequest } = this.state
        if (!selectedItem) return null

        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const itemTotal = this.calculateCateringTotal()
        const mainImage = selectedItem.image
        const minPersons = selectedItem.min_persons || 0
        const maxPersons = selectedItem.max_persons || 100
        const personPrice = selectedItem.person_price || 0

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#fff',
                zIndex: 100,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
                {/* Header with Back button and Image */}
                <div style={{
                    position: 'relative',
                    minHeight: '200px',
                    maxHeight: '250px',
                    backgroundColor: '#f5f5f5',
                    flexShrink: 0,
                }}>
                    <div
                        onClick={this.closeCateringItemDetail}
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '15px',
                            color: '#00547e',
                            cursor: 'pointer',
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '14px',
                            fontWeight: '600',
                            backgroundColor: 'rgba(255,255,255,0.9)',
                            padding: '5px 10px',
                            borderRadius: '5px',
                        }}
                    >
                        <span style={{ fontSize: '18px' }}>{'<'}</span> Back
                    </div>
                    <img
                        src={mainImage ? Constant.getImage() + mainImage : './assets/images/waves-logo.svg'}
                        alt={selectedItem.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                        onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                    />
                </div>

                {/* Scrollable Content */}
                <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '20px',
                }}>
                    {/* Item Name and Price with Person Counter */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px',
                    }}>
                        <div>
                            <h3 style={{ color: '#00547e', margin: '0 0 5px 0', fontSize: '18px' }}>
                                {selectedItem.name}
                            </h3>
                            <p style={{ color: '#00547e', margin: 0, fontWeight: '600' }}>
                                {selectedItem.item_amount} {currency}
                            </p>
                            {personPrice > 0 && (
                                <p style={{ color: '#888', margin: '5px 0 0 0', fontSize: '12px' }}>
                                    (Extra person: {personPrice} {currency}/person)
                                </p>
                            )}
                        </div>
                        {/* Person Counter */}
                        <div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                padding: '5px 10px',
                            }}>
                                <span
                                    onClick={() => this.handlePersonCount(false)}
                                    style={{
                                        cursor: personCount <= minPersons ? 'not-allowed' : 'pointer',
                                        padding: '0 8px',
                                        fontSize: '18px',
                                        color: personCount <= minPersons ? '#ccc' : '#00547e',
                                    }}
                                >
                                    -
                                </span>
                                <span style={{ minWidth: '30px', textAlign: 'center' }}>{personCount}</span>
                                <span
                                    onClick={() => this.handlePersonCount(true)}
                                    style={{
                                        cursor: personCount >= maxPersons ? 'not-allowed' : 'pointer',
                                        padding: '0 8px',
                                        fontSize: '18px',
                                        color: personCount >= maxPersons ? '#ccc' : '#00547e',
                                    }}
                                >
                                    +
                                </span>
                            </div>
                            <p style={{ color: '#888', margin: '5px 0 0 0', fontSize: '11px', textAlign: 'center' }}>
                                {minPersons}-{maxPersons} persons
                            </p>
                        </div>
                    </div>

                    {/* Description */}
                    <div
                        style={{
                            fontSize: '13px',
                            color: '#666',
                            marginBottom: '20px',
                            lineHeight: '1.5',
                        }}
                        dangerouslySetInnerHTML={{ __html: selectedItem.description }}
                    />

                    {/* Catering Categories */}
                    {selectedItem.catering_categories && selectedItem.catering_categories.map((category) => {
                        const remaining = this.getRemainingItems(category.id, category.max_items)
                        const categoryOptions = selectedCateringOptions[category.id] || {}
                        // Non-addon categories are compulsory - show in red
                        const isCompulsory = !category.is_addon

                        return (
                            <div key={category.id} style={{ marginBottom: '25px' }}>
                                {/* Category Header */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '15px',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px',
                                }}>
                                    <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                        {category.name}
                                    </h4>
                                    {/* Only show "Choose X more" for compulsory (non-addon) categories when items remaining */}
                                    {isCompulsory && remaining > 0 && (
                                        <span style={{
                                            color: '#dc3545',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                        }}>
                                            Choose {remaining} more
                                        </span>
                                    )}
                                </div>

                                {/* Category Items */}
                                {category.items.map((item) => {
                                    const itemQty = categoryOptions[item.id] || 0
                                    // Check selection type: 'single' = max 1 per item, 'multiple' = can add more
                                    const isSingleSelection = item.selection === 'single'

                                    return (
                                        <div
                                            key={item.id}
                                            style={{
                                                border: '1px solid #eee',
                                                borderRadius: '8px',
                                                padding: '15px',
                                                marginBottom: '10px',
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                            }}>
                                                <div style={{ flex: 1, paddingRight: '15px' }}>
                                                    <h5 style={{
                                                        color: '#00547e',
                                                        margin: '0 0 8px 0',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                    }}>
                                                        {item.name}
                                                    </h5>
                                                    {item.desc && (
                                                        <p style={{
                                                            color: '#888',
                                                            fontSize: '12px',
                                                            margin: '0 0 8px 0',
                                                            lineHeight: '1.4',
                                                        }}>
                                                            {item.desc}
                                                        </p>
                                                    )}
                                                    {/* Show price for addon items */}
                                                    {category.is_addon && (
                                                        <p style={{
                                                            color: '#00547e',
                                                            fontSize: '13px',
                                                            margin: 0,
                                                            fontWeight: '500',
                                                        }}>
                                                            {item.price} {currency}
                                                        </p>
                                                    )}
                                                </div>
                                                {/* Quantity Counter */}
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '5px',
                                                    padding: '3px 8px',
                                                }}>
                                                    <span
                                                        onClick={() => this.handleCateringOptionChange(category.id, item.id, false, category.max_items, item.selection)}
                                                        style={{
                                                            cursor: itemQty === 0 ? 'not-allowed' : 'pointer',
                                                            padding: '0 5px',
                                                            fontSize: '16px',
                                                            color: itemQty === 0 ? '#ccc' : '#00547e',
                                                        }}
                                                    >
                                                        -
                                                    </span>
                                                    <span style={{
                                                        minWidth: '20px',
                                                        textAlign: 'center',
                                                        color: '#00547e',
                                                    }}>
                                                        {itemQty}
                                                    </span>
                                                    <span
                                                        onClick={() => this.handleCateringOptionChange(category.id, item.id, true, category.max_items, item.selection)}
                                                        style={{
                                                            cursor: (remaining === 0 || (isSingleSelection && itemQty >= 1)) ? 'not-allowed' : 'pointer',
                                                            padding: '0 5px',
                                                            fontSize: '16px',
                                                            color: (remaining === 0 || (isSingleSelection && itemQty >= 1)) ? '#ccc' : '#00547e',
                                                        }}
                                                    >
                                                        +
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}

                    {/* Special Request */}
                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: '600' }}>
                            Any special request?
                        </h4>
                        <textarea
                            placeholder="your request"
                            value={specialRequest}
                            onChange={(e) => this.setState({ specialRequest: e.target.value })}
                            style={{
                                width: '100%',
                                minHeight: '80px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '12px',
                                fontSize: '14px',
                                resize: 'vertical',
                                boxSizing: 'border-box',
                            }}
                        />
                    </div>
                </div>

                {/* Add to Basket Button - Fixed at bottom */}
                <div style={{
                    padding: '15px 20px',
                    borderTop: '1px solid #eee',
                    backgroundColor: '#fff',
                    flexShrink: 0,
                }}>
                    <button
                        onClick={this.addCateringItemToCart}
                        style={{
                            width: '100%',
                            backgroundColor: '#00547e',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '15px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <span>Add To Basket</span>
                        <span>{itemTotal} {currency}</span>
                    </button>
                </div>
            </div>
        )
    }

    // Render catering item card (for listing)
    renderCateringItemCard = (item) => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))

        return (
            <div
                key={item.id}
                onClick={() => this.openCateringItemDetail(item)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '15px',
                    borderBottom: '1px solid #eee',
                    cursor: 'pointer',
                }}
            >
                <img
                    src={item.image ? Constant.getImage() + item.image : './assets/images/waves-logo.svg'}
                    alt={item.name}
                    style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '8px',
                        objectFit: 'cover',
                        marginRight: '15px',
                    }}
                    onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                />
                <div>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '14px', fontWeight: '500' }}>
                        {item.name}
                    </h5>
                    <p style={{ margin: 0, color: '#00547e', fontSize: '13px', fontWeight: '500' }}>
                        {item.item_amount} {currency}
                    </p>
                </div>
            </div>
        )
    }

    // Render catering cart item with selected options
    renderCateringCartItem = (cartItem) => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const selectedOptions = cartItem.selectedCateringOptions || {}
        const categories = cartItem.cateringCategories || []

        // Build list of selected items from each category
        const selectedItemsList = []
        categories.forEach((category) => {
            const categoryOptions = selectedOptions[category.id] || {}
            category.items.forEach((item) => {
                const qty = categoryOptions[item.id] || 0
                if (qty > 0) {
                    selectedItemsList.push({
                        name: item.name,
                        qty: qty,
                    })
                }
            })
        })

        return (
            <div
                key={cartItem.id}
                style={{
                    display: 'flex',
                    padding: '15px',
                    borderBottom: '1px solid #eee',
                    backgroundColor: '#fff',
                }}
            >
                <img
                    src={cartItem.img ? Constant.getImage() + cartItem.img : './assets/images/waves-logo.svg'}
                    alt={cartItem.title}
                    style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '8px',
                        objectFit: 'cover',
                        marginRight: '15px',
                        flexShrink: 0,
                    }}
                    onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                />
                <div style={{ flex: 1 }}>
                    <h5 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: '600' }}>
                        {cartItem.title}
                    </h5>
                    {/* Selected options list */}
                    <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.6' }}>
                        {selectedItemsList.map((item, index) => (
                            <div key={index}>
                                - {item.name} x {item.qty}
                            </div>
                        ))}
                    </div>
                    {/* Price */}
                    <p style={{ margin: '10px 0 0 0', color: '#00547e', fontSize: '14px', fontWeight: '600' }}>
                        {cartItem.price} {currency}
                    </p>
                </div>
            </div>
        )
    }

    // Render cart view
    renderCartView = () => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const cartItems = Object.values(this.state.cartItemList)
        const cartCount = cartItems.length

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Cart Items */}
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    {cartCount > 0 ? (
                        <div>
                            {cartItems.map((item, index) => {
                                // Check if it's a catering item
                                if (item.isCateringItem) {
                                    return <div key={index}>{this.renderCateringCartItem(item)}</div>
                                }
                                // Regular item
                                return <div key={index}>{this.productCard(item.img, item.title, item.price, item, 1)}</div>
                            })}
                        </div>
                    ) : (
                        <div className="mt-3 no-data" style={{ textAlign: 'center', padding: '40px 20px' }}>
                            <h5>No Item Added</h5>
                        </div>
                    )}
                </div>

                {/* Total Amount Bar */}
                {cartCount > 0 && (
                    <div style={{
                        background: 'linear-gradient(135deg, #00547e 0%, #00a8a8 100%)',
                        padding: '15px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderRadius: '8px',
                        margin: '10px 15px',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{
                                backgroundColor: '#fff',
                                color: '#00547e',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                fontWeight: '600',
                                fontSize: '14px',
                            }}>
                                {cartCount}
                            </span>
                            <span style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>
                                Total Amount
                            </span>
                        </div>
                        <span style={{ color: '#fff', fontSize: '16px', fontWeight: '600' }}>
                            {this.state.totalAmt} {currency}
                        </span>
                    </div>
                )}
            </div>
        )
    }

    render() {
        const { activeTab, activeAddOnSubTab } = this.state
        return (
            <>
                <div className="scroll" style={{ position: 'relative' }}>
                    <div>
                        {(this.state.isProcessingCheckout || this.state.isProcessingPayment || this.state.initialLoading) && (
                            <div className="loader-overlay">
                                <div className="loader"></div>
                            </div>
                        )}
                        {this.state.showCheckout ? (
                            <div style={{ padding: '20px' }}>
                                {/* Header */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '20px',
                                }}>
                                    <img
                                        src="./assets/icon/concierge/arrow-prev-back.svg"
                                        alt="Back"
                                        style={{ width: '20px', cursor: 'pointer' }}
                                        onClick={this.handleCart}
                                    />
                                    <h1 style={{
                                        flex: 1,
                                        textAlign: 'center',
                                        margin: 0,
                                        fontSize: '20px',
                                        fontWeight: '500',
                                        color: '#333',
                                    }}>Checkout</h1>
                                    <div style={{ width: '20px' }}></div>
                                </div>

                                {/* Event Info Card */}
                                <div style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '15px 20px',
                                    marginBottom: '20px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                    <div>
                                        <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#666' }}>
                                            From
                                        </p>
                                        <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#00547e' }}>
                                            {moment(this.state.bookingData?.event_date, 'YYYY-MM-DD').format('dddd, D MMMM')}
                                        </p>
                                        <span style={{ fontSize: '13px', color: '#00547e' }}>
                                            {this.state.bookingData?.start_time || ''}
                                        </span>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        {this.state.bookingData?.event_image && (
                                            <img
                                                src={Constant.getImage() + this.state.bookingData?.event_image}
                                                alt={this.state.bookingData?.event_name || this.state.title}
                                                style={{
                                                    width: '80px',
                                                    height: '80px',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                }}
                                            />
                                        )}
                                        <h5 style={{ margin: '0 0 5px 0', fontSize: '15px', fontWeight: '600', color: '#00547e' }}>
                                            {this.state.bookingData?.event_name || this.state.title}
                                        </h5>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>
                                            To
                                        </p>
                                        <p style={{ margin: 0, fontSize: '13px', color: '#00547e' }}>
                                            {moment(this.state.bookingData?.event_date, 'YYYY-MM-DD').format('dddd, D MMMM')}
                                        </p>
                                        <span style={{ fontSize: '13px', color: '#00547e' }}>
                                            {this.state.bookingData?.end_time ? `${this.state.bookingData?.end_time}` : ''}
                                        </span>
                                    </div>
                                </div>

                                {/* Payment Summary Card */}
                                <div style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '20px',
                                }}>
                                    <h3 style={{
                                        margin: '0 0 20px 0',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        color: '#333',
                                    }}>Payment Summary</h3>

                                    {/* Event Amount */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Event Amount</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.event_amount || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Store Items Total */}
                                    {/* <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Store Items Total</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.store_items_total || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div> */}

                                    {/* Catering Total */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Catering Total</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.catering_total || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Delivery Charge */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Delivery Charge</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.delivery_charge || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Cost Of Service */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Cost Of Service</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.cost_of_service || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Coupon Applied Amount */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Coupon Applied Amount</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.coupon_applied_amount || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* VAT */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #f0f0f0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Vat ({this.state.bookingData?.vat_percentage || 0}%)</p>
                                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            {this.state.bookingData?.vat || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Total */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '15px 0 0 0',
                                    }}>
                                        <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>Total</p>
                                        <span style={{ fontSize: '16px', fontWeight: '700', color: '#00547e' }}>
                                            {this.state.bookingData?.total_booking_amount || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                                        </span>
                                    </div>

                                    {/* Process Payment Button */}
                                    <button
                                        onClick={this.processPayment}
                                        disabled={this.state.isProcessingPayment}
                                        style={{
                                            width: '100%',
                                            marginTop: '20px',
                                            padding: '15px',
                                            backgroundColor: this.state.isProcessingPayment ? '#6c9ab5' : '#00547e',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            cursor: this.state.isProcessingPayment ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                        }}
                                    >
                                        {this.state.isProcessingPayment && (
                                            <div
                                                style={{
                                                    width: 18,
                                                    height: 18,
                                                    border: '2px solid #fff',
                                                    borderTop: '2px solid transparent',
                                                    borderRadius: '50%',
                                                    animation: 'spin 1s linear infinite',
                                                }}
                                            />
                                        )}
                                        {this.state.isProcessingPayment ? 'Processing...' : `Process Payment ${this.state.bookingData?.total_booking_amount || 0} ${getCurrency(localStorage.getItem('countryShortName'))}`}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="top-button">
                                    <div className="button-data">
                                        <span>
                                            {this.state.showCart ? (
                                                <img
                                                    src="./assets/icon/concierge/arrow-prev-back.svg"
                                                    alt="Back"
                                                    style={{
                                                        width: '25px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={this.handleCart}
                                                />
                                            ) : (
                                                ''
                                            )}
                                        </span>
                                        <h1 className="m-0 heading">{this.state.showCart ? 'Cart' : this.state.title}</h1>
                                        <div
                                            style={{
                                                height: '22px',
                                                position: 'relative',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => this.setState({ showCart: this.state.showCart ? false : true })}
                                        >
                                            {' '}
                                            <img
                                                src="./assets/icon/concierge/cart.svg"
                                                alt="Cart"
                                                style={{
                                                    width: '30px',
                                                }}
                                            />
                                            {Object.keys(this.state.cartItemList).length == 0 ? (
                                                ''
                                            ) : (
                                                <span
                                                    className="m-0 heading"
                                                    style={{
                                                        position: ' absolute',
                                                        right: ' -4px',
                                                        top: ' -3px',
                                                        height: ' 19px',
                                                        width: ' 18px',
                                                        backgroundColor: ' #adadff',
                                                        fontSize: ' 10px',
                                                        textAlign: ' center',
                                                        borderRadius: ' 15px',
                                                        lineHeight: ' 18px',
                                                    }}
                                                >
                                                    {Object.keys(this.state.cartItemList).length}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {this.state.showCart ? (
                                    <div className="add-on-data" style={{ height: '100%' }}>
                                        {this.renderCartView()}
                                    </div>
                                ) : (
                                    <div className="add-on-data">
                                        <div
                                            style={{
                                                overflow: 'auto',
                                                padding: '0 10px',
                                            }}
                                        >
                                            <div className="add-tab">
                                                {this.state.tabList?.map((ele, i) => {
                                                    return (
                                                        <div
                                                            key={i}
                                                            className={`box ${activeTab === ele.id ? 'select' : ''}`}
                                                            onClick={() => this.setActiveTab(ele.id)}
                                                        >
                                                            {this.imageManger(ele.imageSelected)}
                                                            <p className="m-0">{ele.name}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>

                                        <div className="tab-content">
                                            <div className="add-cat">
                                                {this.state.isLoadingStores ? (
                                                    this.renderInlineLoader(80)
                                                ) : (
                                                    this.state.circleTab?.map((ele, i) => {
                                                        return (
                                                            <div
                                                                key={i}
                                                                className={`add-cat-data ${this.state.activeAddOnTab.id === ele.id ? 'select' : ''}`}
                                                                onClick={() => this.setActiveAddOnTab(ele)}
                                                            >
                                                                {this.imageManger(ele.shop_img)}
                                                                <p className="mb-1">{ele.shop_name}</p>
                                                            </div>
                                                        )
                                                    })
                                                )}
                                            </div>
                                            <div>
                                                {this.state.isLoadingItems ? (
                                                    this.renderInlineLoader(150)
                                                ) : this.state.foodOrStoreSelectOnceData && this.state.foodOrStoreSelectOnceData.name && (
                                                    <>
                                                        <div className="box-details">
                                                            <h4>{this.state.foodOrStoreSelectOnceData?.name}</h4>
                                                            <ul>
                                                                {Array.apply(null, Array(5))?.map((ele, i) => {
                                                                    return (
                                                                        <li key={i}>
                                                                            {i > this.state.foodOrStoreSelectOnceData?.ratings - 1 ? (
                                                                                <img
                                                                                    src="./assets/icon/concierge/unfill-star.svg"
                                                                                    alt=""
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src="./assets/icon/concierge/star.svg"
                                                                                    alt=""
                                                                                />
                                                                            )}
                                                                        </li>
                                                                    )
                                                                })}
                                                            </ul>
                                                            <span
                                                                onClick={() =>
                                                                    this.setState({ descriptionExpand: this.state.descriptionExpand ? 0 : 1 })
                                                                }
                                                            >
                                                                {this.state.descriptionExpand ? (
                                                                    <p>
                                                                        {this.state.foodOrStoreSelectOnceData?.description &&
                                                                            this.state.foodOrStoreSelectOnceData?.description.length > 100
                                                                            ? this.state.foodOrStoreSelectOnceData?.description.substring(0, 100) + '...'
                                                                            : this.state.foodOrStoreSelectOnceData?.description}
                                                                    </p>
                                                                ) : (
                                                                    <p>{this.state.foodOrStoreSelectOnceData?.description}</p>
                                                                )}
                                                            </span>
                                                            <div className="fee-del">
                                                                <span>Delivery Fee:</span>
                                                                <p>
                                                                    {this.state.foodOrStoreSelectOnceData?.deliverCharge}{' '}
                                                                    {getCurrency(localStorage.getItem('countryShortName'))}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {this.state.foodOrStoreSelectOnceData.categories ? (
                                                            <div className="child-data">
                                                                <div className="child-box">
                                                                    {this.state.foodOrStoreSelectOnceData?.categories.map((ele, index) => {
                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className={`box ${activeAddOnSubTab == index ? 'select' : ''}`}
                                                                                onClick={() => this.setActiveAddOnSubTab(index)}
                                                                            >
                                                                                <p>{ele.name}</p>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        {this.state.foodOrStoreSelectOnceData?.categories[activeAddOnSubTab] ? (
                                                                            <div style={{ backgroundColor: '#fff' }}>
                                                                                {this.state.foodOrStoreSelectOnceData?.categories[
                                                                                    activeAddOnSubTab
                                                                                ]?.storeItems.map((ele, index) => {
                                                                                    // All catering/event items use the same card style
                                                                                    return (
                                                                                        <div key={index}>
                                                                                            {this.renderCateringItemCard(ele)}
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        ) : (
                                                                            <div className="mt-3 no-data">
                                                                                <h5 className="">No Item</h5>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {this.state.detailsOfitem && this.state.detailsOfitem.id ? <div>{this.setDetailsOfitem()}</div> : ''}
                        {this.state.showItemDetail && this.renderCateringItemDetail()}
                    </div>
                </div>
                {!this.state.showCheckout && !this.state.showItemDetail && (
                    <div>
                        {this.storeMinOrderAmtAlert()}
                        <div
                            style={{
                                padding: '10px 20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderTop: '1px solid #ccc',
                            }}
                        >
                            <button
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    width: '100%',
                                }}
                                type="button"
                                className="btn book-btn"
                                onClick={() => this.bottmBtn()}
                                disabled={this.state.isProcessingCheckout}
                            >
                                {this.state.isProcessingCheckout ? (
                                    <>
                                        <div
                                            style={{
                                                width: 18,
                                                height: 18,
                                                border: '2px solid #fff',
                                                borderTop: '2px solid transparent',
                                                borderRadius: '50%',
                                                animation: 'spin 1s linear infinite',
                                            }}
                                        />
                                        <div>Processing...</div>
                                    </>
                                ) : this.state.showCart ? (
                                    <div>Proceed To Checkout</div>
                                ) : (
                                    <div>Next</div>
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </>
        )
    }
}

export default KashtaAddOns
